<template>
  <div class="row">
    <div class="oferta">
      <div class="oferta__header" :style="{backgroundColor: oferta.color ? oferta.color : '#444'}">
        <h2 class="modelo">{{oferta.modelo}}</h2>
        <p class="versiones">{{oferta.version}}</p>
        <p class="enlaces" v-html="oferta.enlaces" v-if="0"></p>
        <img
          class="highlighted"
          :src="oferta.ribbon"
          alt="Oferta especial"
          v-show="oferta.destacado"
          v-if="0"
        />
      </div>

      <div class="oferta__body">
        <img class="imagen" :src="oferta.imagenUrl" :alt="oferta.titulo" />
        <div class="comprimir">
          <h3 class="titulo">{{oferta.titulo}} <span>{{oferta.descripcion}}</span></h3>
          <p class="descripcion" v-text="oferta.descripcion" v-if="0"></p>
          <a v-on:click="showAlert(oferta.legales)" class="terms">Legales</a>
        </div>
      </div>

      <div class="oferta__footer">
        <div style="width: 100%; display: flex; align-items: center; justify-content: space-between;">
          <div class="cta" v-if="!ocultar">
            <a href="https://www.volkswagen.com.ar/app/local/vwfs-calculadora-financiera/" target="_blank" class="btn btn-primary btn-block">Simulá tu préstamo</a>
          </div>
          <div class="cta" v-if="oferta.boton">
            <a style="color: white; background: #001e50; border-color: #001e50; padding: 0px 20px;" :href="oferta.boton" class="btn btn-primary btn-block">¡Lo quiero!</a>
          </div>
        </div>
        <p class="vigencia" style="margin-top: 15px;"><small>Vigente hasta {{oferta.vigencia}}</small></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["oferta", "ocultar"],
  methods: {
    /**
     * @param String message
     * @param Object options default { title, okLabel = 'OK', size }
     */
    showAlert(copy) {
      const options = {};
      this.$dialogs.alert(copy, options);
    }
  }
};
</script>

<style lang="scss" scoped>
// COLORES -----------------
$hover: #f3f5f6;
$blue: #0099da;
$black: #1d1f20;
$white: #ffffff;
// -------------------------

// FOR DEVELOPMENT ONLY -----------------
// * {
//   outline: 1px dashed rgba(red, 0.2);
//   transition: all 300ms ease-in-out;
// }
// -------------------------

// RESETS -----------------
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
}
// -------------------------

.wrapper {
  background-color: $white;

  @media (min-width: 480px) {
    padding-right: 2rem;
    padding-left: 2rem;

    &:not(:nth-last-child(-n + 3)) {
      padding-bottom: 2rem;
    }

    &:nth-child(n + 4) {
      padding-top: 2rem;
    }
  }

  @media (max-width: 480px) {
    &:nth-child(even) {
      background-color: $hover;
    }
  }
}

.oferta {
  padding: 2rem;
  max-height: 100vh;

  &__header {
    height: 21rem;
    padding: 1.9em;
    color: white;
    @media (max-width: 677px) {
      height: 13.5em;
    }

    .modelo {
      font-size: 1.9em;
      letter-spacing: 0.02em;
      color: inherit;
      line-height: 1;
      font-weight: bold;
    }

    .versiones {
      font-size: 0.9em;
      margin-top: 3px;
      font-weight: inherit;
      line-height: 1;
    }
  }

  &__body {
    margin-top: -8em;
    @media all and (min-width: 677px) {
      margin-top: -7em;
    }
    @media (max-width: 677px) {
      margin-top: -9em;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
      @media (max-width: 677px) {
        width: 108%;
        margin-left: -4%;
      }
    }

    .comprimir {
      padding: 1.2em 1.75em;
      @media (max-width: 677px) {
        text-align: center;
      }
    }

    .titulo {
      font-size: 1.35em;
      line-height: 1.2;
      letter-spacing: -0.035em;
      overflow: hidden;
      height: 2.4em;
      font-weight: inherit;
      span {
        font-weight: 300;
        letter-spacing: -0.015em;
      }
    }

    .terms {
      cursor: pointer;
      color: black;
      text-decoration: underline;
      font-size: 1.1em;
      margin-top: 4px;
      display: inline-block;
      font-weight: 300;
    }
  }

  &__footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      margin-top: 1.3em;
    .cta a {
      cursor: pointer;
      color: rgb(0, 30, 80);
      background: transparent;
      border-color: rgb(0, 30, 80);
      display: inline-flex;
      text-align: center;
      -webkit-box-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      align-items: center;
      min-height: 50px;
      margin: 0px;
      padding: 0px 30px;
      border-width: 2px;
      border-style: solid;
      border-color: initial;
      border-image: initial;
      border-radius: 25px;
      outline: none;
      transition: all 0.2s ease-in-out 0s;
      font-size: 1.25em;
      &:hover {
        color: rgb(0, 64, 197);
        background: transparent;
        border-color: rgb(0, 64, 197);
      }
    }
    .vigencia {
      margin-top: 3px;
      font-weight: 300;
    }
  }
}
</style>
